import React from 'react';
import {Button, Dimmer} from 'semantic-ui-react';
import ClientForm from '../form/clientForm';
import './styles.scss';
import StateForm from '../form/stateForm';
import VehicleForm from '../form/vehicleForm';
import TimeLine from '../../commons/timeLine';
import {connect} from 'react-redux';
import {useModalOrderInfo} from './useModalOrderInfo';
import {Actions} from '../../../../common/actions';
import ModalUpdateClient from '../../commons/modalUpdateClient';
import Modal from 'react-modal';
import {floatingInvCustomStyles} from '../../../constants/modalStyles';

const ModalOrderInfo = ({
  addMessageBoxError,
  advisersList,
  cleanCurrentLineFloating,
  currentLineOriginal,
  dealerId,
  isUserTde,
  listDealers,
  minValue,
  putFloatingInventory,
  setShowModalOrderInfo,
  showModalOrderInfo,
  currentLine,
  setCurrentLine,
  currentLineError,
  setCurrentLineError,
  setCurrentFloatingLine,
  userEmail,
  currentClient,
  currentFlUserGroup,
  setCurrentFloatingOrderClient,
  filters,
}) => {
  const {
    'actions': {
      handleChange,
      handleSave,
      save,
      setShowClientDataModal,
      handleInputTextChange,
    },
    'dataValues': {
      advisersListDD,
      listDealersDD,
      isAvailable,
      timeLine,
      showClientDataModal,
      validating,
      passedSolNac,
    },
  } = useModalOrderInfo({
    addMessageBoxError,
    cleanCurrentLineFloating,
    dealerId,
    isUserTde,
    listDealers,
    minValue,
    currentLineOriginal,
    putFloatingInventory,
    advisersList,
    currentLine,
    setCurrentLine,
    currentLineError,
    setCurrentLineError,
    setCurrentFloatingLine,
    userEmail,
    currentClient,
    currentFlUserGroup,
    setCurrentFloatingOrderClient,
    filters,
  });
  return (
    <>
      <Modal
        isOpen={showModalOrderInfo}
        style={floatingInvCustomStyles}
      >
        <Dimmer active={validating}>
          <div className='loader' />
        </Dimmer>
        <div className='container-modal-reserve'>
          <div className='modal-fl-inventory-header'>
            {`${currentLine.id ? 'EDITAR' : 'CREAR'}`} RESERVA
          </div>
          <div className='modal-fl-inventory-content'>
            <TimeLine data={timeLine} />
            <div className='floating-inv-row1'>
              <StateForm
                data={currentLine}
                dataError={currentLineError}
                handleChange={handleChange}
                advisersListDD={advisersListDD}
                listDealersDD={listDealersDD}
                handleInputTextChange={handleInputTextChange}
                isAvailable={isAvailable}
                passedSolNac={passedSolNac}
                currentLineOriginal={currentLineOriginal}
              />
            </div>
            <div className='floating-inv-row2'>
              <div className='floating-inv-col1'>
                <ClientForm
                  data={currentLine}
                  dataError={currentLineError}
                  handleChange={handleChange}
                  currentLineOriginal={currentLineOriginal}
                  handleInputTextChange={handleInputTextChange}
                  isAvailable={isAvailable}
                  passedSolNac={passedSolNac}
                />
              </div>
              <div className='floating-inv-col2'>
                <VehicleForm
                  data={currentLine}
                />
              </div>
            </div>
          </div>
          <div className='modal-fl-inventory-actions'>
            <Button
              size='mini'
              onClick={() => {
                setShowModalOrderInfo(false);
                cleanCurrentLineFloating();
              }}
            >
              CERRAR
            </Button>
            <Button
              size='mini'
              color='blue'
              onClick={() => {
                handleSave();
              }}
              disabled={!isAvailable || validating}
              loading={validating}
            >
              GUARDAR CAMBIOS
            </Button>
          </div>
        </div>
      </Modal>
      <ModalUpdateClient
        setShowModal={setShowClientDataModal}
        showModal={showClientDataModal}
        save={save}
      />
    </>
  );
};

const {
  addMessageBoxError,
  cleanCurrentLineFloating,
  putFloatingInventory,
  setCurrentFloatingLine,
  setCurrentFloatingOrderClient,
} = Actions;

const mapStateToProps = (state) => ({
  'loading': state.floatingInventory.loading,
  'currentLineOriginal': state.floatingInventory.currentLine,
  'isUserTde': state.session.isUserFromTDE,
  'dealerId': state.session.dealerId,
  'minValue': state.exemptionManagment.minValue,
  'advisersList': state.floatingInventory.advisersList,
  'listDealers': state.dealer.list,
  'userEmail': state.session.userEmail,
  'currentClient': state.floatingInventory.currentClient,
  'currentFlUserGroup': state.floatingInventory.currentFlUserGroup,
});

export default connect(mapStateToProps, {
  addMessageBoxError,
  putFloatingInventory,
  cleanCurrentLineFloating,
  setCurrentFloatingLine,
  setCurrentFloatingOrderClient,
})(ModalOrderInfo);
